module.exports = __webpack_public_path__ + "img/gywm_03@2x.a1e9de68.png";